
/**
 * Class du produit dose Preconisations|Modulation à la micro
 */
export class mcFertilizer {
    Dose: number;
    //code produit
    code:string;
}